import React, { useEffect, useRef, useState, useCallback } from 'react'
import { Link, useHistory, useLocation } from 'react-router-dom'
import { Body } from 'components/Shell/Shell'
import { FieldError } from './CreateAccount'
import { parseUrlQuery } from 'utilities'
import { PARSE_PASSWORD_RESET_TOKEN, CHANGE_PASSWORD } from 'requests'
import { toggleLoginModal } from '../../../actions'
import { useDispatch } from 'react-redux'

const minimumNumPassword = process.env.MINIMUM_PASSWORD_LENGTH || 8

export default function ChangePassword() {
  const history = useHistory()
  const location = useLocation()

  const [errors, setErrors] = useState({})
  const [token, setToken] = useState(null)
  const [tokenExpired, setTokenExpired] = useState(false)
  const [parsing, setParsing] = useState(true)
  const [username, setUsername] = useState('')
  const [setPassword, setSetPassword] = useState(false)
  const dispatch = useDispatch()

  const passwordRef = useRef(null)
  const confirmPasswordRef = useRef(null)

  useEffect(() => {
    dispatch(toggleLoginModal(false))
    const search = location.search
    const { token } = parseUrlQuery(search)

    if (location.pathname === '/setpassword') {
      setSetPassword(true)
    }

    if (!token) {
      history.replace('/auth')
    } else {
      setToken(token)
      parseToken(token)
    }
  }, [location, history])

  const validate = useCallback(() => {
    const password = passwordRef.current.value
    const confirmPassword = confirmPasswordRef.current.value
    let errs = {}

    if (!password) {
      errs.password = 'A password is required'
    } else if (password.length < minimumNumPassword) {
      errs.password = `Password must be at least ${minimumNumPassword} characters`
    }
    if (password !== confirmPassword) {
      errs.confirmPassword = 'Passwords must match'
    }

    if (Object.keys(errs).length > 0 && token !== null) {
      setErrors(errs)
    } else {
      setErrors({})
      changePassword(password)
    }
  }, [token])

  const parseToken = (token) => {
    PARSE_PASSWORD_RESET_TOKEN(
      token,
      ({ username, expired }) => {
        setUsername(username)
        setParsing(false)
      },
      (err) => {
        console.error(err)
        if (err.code === 'auth/resetTokenExpired') {
          setToken(null)
          setTokenExpired(true)
          setParsing(false)
        } else {
          setGenericGlobalError()
        }
      }
    )
  }

  const changePassword = (password) => {
    CHANGE_PASSWORD(
      { token, password },
      () => {
        history.replace('/auth?changed=true')
      },
      (err) => {
        console.error(err)
        setGenericGlobalError(err)
      }
    )
  }

  const setGenericGlobalError = (message) => {
    setErrors((prev) => ({
      ...prev,
      submit:
        message ||
        `Oops, something went wrong. You can try submitting again later. If the problem persists please contact customer support.`,
    }))
  }

  const checkEnter = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault()
      validate()
    }
  }

  return (
    <Body className="login-redirector">
      {!parsing && (
        <div className="admin-login-wrapper login-modal-new animated fadeInDown fast-animation">
          <div className="login-column" style={{ paddingTop: 95 }}>
            <div className="banner">{setPassword ? 'Set Password' : 'Change Password'}</div>
            {tokenExpired ? (
              <FieldError>
                This password link has expired, you can{' '}
                <Link to="/auth?page=forgot">request a new one</Link>, or{' '}
                <Link to="/auth">login here</Link>.
              </FieldError>
            ) : (
              <form className="login forgot-password">
                <p className="description">
                  {setPassword
                    ? 'Please set a password for the account associated with'
                    : 'Please pick a new password for the account associated with'}
                  <strong>{` ${username}`}</strong>.
                </p>
                <div className="field">
                  <label>{setPassword ? 'Password' : 'New Password'}</label>
                    {process.env.PASSWORD_REQUIREMENTS_ACCOUNT_CREATE ? (
                      <p className="description" id="password-description">
                        <span dangerouslySetInnerHTML={{__html: process.env.PASSWORD_REQUIREMENTS_ACCOUNT_CREATE}}/>
                      </p>
                    ) : null
                    }
                  <input type="password" ref={passwordRef} onKeyDown={checkEnter} />
                  <FieldError>{errors.password}</FieldError>
                </div>
                <div className="field">
                  <label>{setPassword ? 'Confirm Password' : 'Confirm New Password'}</label>
                  <input type="password" ref={confirmPasswordRef} onKeyDown={checkEnter} />
                  <FieldError>{errors.confirmPassword}</FieldError>
                </div>
                <div className="button-wrapper create-wrapper">
                  <button
                    type="button"
                    className="btn-raised btn-light-primary submit"
                    onClick={validate}
                  >
                    SAVE CHANGES
                  </button>
                  <FieldError>{errors.submit}</FieldError>
                </div>
              </form>
            )}
          </div>
        </div>
      )}
    </Body>
  )
}
